/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpNetworkInterface } from './gcpNetworkInterface';


export interface GcpInstancesResponse { 
    /**
     * The instance id
     */
    id: number;
    /**
     * Name of the instance
     */
    name: string;
    image_name: string;
    /**
     * Public Ip
     */
    public_ip?: string;
    /**
     * Region of the instance
     */
    region?: string;
    /**
     * State of the instance
     */
    state: string;
    version?: string;
    /**
     * Zone-Id of the instance
     */
    zone: string;
    /**
     * Machine type
     */
    machine_type: string;
    /**
     * CPU Platform
     */
    cpu_platform: string;
    /**
     * Timestamp when the instance was created
     */
    create_time: Date;
    /**
     * Deletion protection
     */
    deletion_protection: boolean;
    /**
     * Timestamp when the instance was last started
     */
    last_start_time: Date;
    network_interfaces?: Array<GcpNetworkInterface>;
}

